(() => {
  function formatDeliveryRange(element) {
    const minimum = Number.parseInt(element.dataset.minDays, 10);
    const maximum = Number.parseInt(element.dataset.maxDays, 10);
    const [year, month, day] = (element.dataset.startDate || '').split('-').map(Number);
    if (!Number.isInteger(minimum) || !Number.isInteger(maximum) || !year || !month || !day) return;

    const start = new Date(Date.UTC(year, month - 1, day));
    function addWorkDays(workDays) {
      const date = new Date(start);
      let added = 0;
      while (added < workDays) {
        date.setUTCDate(date.getUTCDate() + 1);
        const weekday = date.getUTCDay();
        if (weekday !== 5 && weekday !== 6) added += 1;
      }
      return date;
    }

    const isArabic = (element.dataset.locale || document.documentElement.lang || '').toLowerCase().startsWith('ar');
    const locale = isArabic ? 'ar-EG-u-ca-gregory' : 'en-GB-u-ca-gregory';
    const monthName = new Intl.DateTimeFormat(locale, { month: 'long', timeZone: 'UTC' });
    const formatDate = date => `${date.getUTCDate()} ${monthName.format(date)}`;
    const from = formatDate(addWorkDays(minimum));
    const to = formatDate(addWorkDays(maximum));
    element.textContent = isArabic
      ? `التوصيل خلال الفترة من ${from} إلى ${to} باستثناء الإجازات`
      : `Delivery from ${from} to ${to}, excluding holidays`;
  }

  function setup(root){
    root.querySelectorAll('[data-os-delivery-range]').forEach(formatDeliveryRange);
    if(root.dataset.ready || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal)return;
    root.querySelectorAll('[data-story-open]').forEach(link=>{
      const dialog=document.getElementById(link.dataset.storyOpen);if(!dialog||!dialog.showModal)return;
      let opener;
      link.addEventListener('click',event=>{event.preventDefault();opener=link;dialog.showModal();document.body.classList.add('os-story-modal-open');dialog.querySelector('[data-story-close]').focus();});
      dialog.querySelector('[data-story-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('keydown',event=>{
        if(event.key!=='Tab')return;
        const focusable=[...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')].filter(element=>element.getClientRects().length);
        const first=focusable[0],last=focusable[focusable.length-1];
        if(!first)return;
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      });
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{document.body.classList.remove('os-story-modal-open');opener?.focus({preventScroll:true});});
    });
    root.dataset.ready='true';
  }
  document.querySelectorAll('[data-os-story]').forEach(setup);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-os-story]').forEach(setup));
})();
